var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.9999V18.3651M12 21.9999H18.3651M12 29.9999H18M12 37.9999H18.3651M41.6348 21.9999H48M42 29.9999H48M41.6348 37.9999H48M22 41.6347V47.9999M30 11.9999V17.9999M30 41.9999V47.9999M38 11.9999V18.3651M38 41.6347V47.9999M26 33.9999H26.02M34 33.9999H34.02M34 25.9999H34.02M26 25.9999H26.02M27.6 41.9999H32.4C35.7604 41.9999 37.4404 41.9999 38.724 41.3459C39.853 40.7707 40.7708 39.8529 41.346 38.7239C42 37.4403 42 35.7603 42 32.3999V27.5999C42 24.2396 42 22.5595 41.346 21.276C40.7708 20.147 39.853 19.2291 38.724 18.6539C37.4404 17.9999 35.7604 17.9999 32.4 17.9999H27.6C24.2397 17.9999 22.5595 17.9999 21.2761 18.6539C20.1471 19.2291 19.2292 20.147 18.654 21.276C18 22.5595 18 24.2396 18 27.5999V32.3999C18 35.7603 18 37.4403 18.654 38.7239C19.2292 39.8529 20.1471 40.7707 21.2761 41.3459C22.5595 41.9999 24.2397 41.9999 27.6 41.9999Z",
    stroke: "#18181B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/electronics.68f4b6bfb466fa39e3540b1ba2943ecb.svg";
export { ForwardRef as ReactComponent };